import React, { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { useSupplier } from "./store";

function CreateSupplier() {
  const { postSupplier, fetchSuppliers } = useSupplier();
  const [show, setShow] = useState(false);
  const [supplierDetails, setSupplierDetails] = useState({
    channel: "",
    code: "",
    supplier_phone_number: "",
    supplier_gst_number: "",
    supplier_id_in_acounting: "",
    supplier_name: "",
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSubmit = (e) => {
    e.preventDefault();
    postSupplier(supplierDetails, fetchSuppliers);
    handleClose();
  };
  const handleChange = (e) => {
    setSupplierDetails((prevSupplierDetails) => {
      return {
        ...prevSupplierDetails,
        [e.target.name]: e.target.value,
      };
    });
    supplierDetails[e.target.name];
  };
  const required = <span className="text-danger">*</span>;
  return (
    <>
      <Button variant="primary" onClick={handleShow} className="me-2">
        Create Supplier
      </Button>
      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form
            className="d-flex flex-column align-items-center justify-content-center"
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Channel</Form.Label>
              <Form.Control
                name="channel"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Code</Form.Label>
              <Form.Control
                name="code"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Supplier Phone Number</Form.Label>
              <Form.Control
                name="supplier_phone_number"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Supplier GST Numbe</Form.Label>
              <Form.Control
                name="supplier_gst_number"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Supplier ID in Accounting</Form.Label>
              <Form.Control
                name="supplier_id_in_acounting"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>{required} Supplier Name</Form.Label>
              <Form.Control
                name="supplier_name"
                onChange={handleChange}
                type="text"
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
  //   return (
  //     <div>

  //     </div>
  //   )
}

export default CreateSupplier;
// {
//     "channel": "new channel",
//     "code": "code",
//     "supplier_phone_number": "0099898564",
//     "supplier_gst_number": "ir 453635",
//     "supplier_id_in_acounting": "RT002",
//     "supplier_name": "Supplier"
// }
